import React, { useState } from "react";
import ReactDOM from "react-dom";
import ProjectLanguages from "../../components/projectLanguages/ProjectLanguages";
import "./GithubRepoCard.css";
import { Fade } from "react-reveal";
import { useTranslation } from "react-i18next";

export default function GithubRepoCard({ repo, theme, categories }) {
  const { t } = useTranslation();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [privateModalOpen, setPrivateModalOpen] = useState(false);

  function openRepoinNewTab(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  function handleCardClick(e) {
    if (repo.isPrivate) {
      setPrivateModalOpen(true);
    } else {
      openRepoinNewTab(repo.url);
    }
  }

  const getCategoryClass = (cat) => {
    if (!cat) return "";
    const catLower = cat.toLowerCase();
    return `category-tag category-${catLower}`;
  };

  // Support both single category (string) and multiple categories (array)
  const categoryArray = categories
    ? (Array.isArray(categories) ? categories : [categories])
    : [];

  return (
    <div className="repo-card-div" style={{ backgroundColor: theme.cardBackground || theme.highlight }} onClick={handleCardClick}>
      <Fade bottom duration={800} distance="20px">
        <div key={repo.id} className="repo-card-body">
          <div className="repo-name-div">
            <div className="repo-name-wrapper">
              <svg
                aria-hidden="true"
                className="octicon repo-svg"
                height="16"
                role="img"
                viewBox="0 0 12 16"
                width="12"
              >
                <path
                  fill-rule="evenodd"
                  d="M4 9H3V8h1v1zm0-3H3v1h1V6zm0-2H3v1h1V4zm0-2H3v1h1V2zm8-1v12c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1zm-1 10H1v2h2v-1h3v1h5v-2zm0-10H2v9h9V1z"
                ></path>
              </svg>
              <p className="repo-name" style={{ color: theme.text }}>
                {repo.name}
              </p>
            </div>
            {categoryArray.length > 0 && (
              <div className="category-tags-wrapper">
                {categoryArray.map((cat, index) => (
                  <span key={index} className={getCategoryClass(cat)}>
                    {cat}
                  </span>
                ))}
              </div>
            )}
          </div>
          <p className="repo-description" style={{ color: theme.text }}>
            {repo.description}
          </p>
          <div className="repo-details">
            <p
              className="repo-creation-date subTitle"
              style={{ color: theme.secondaryText }}
            >
              {t("projects.createdOn")} {repo.createdAt.split("T")[0]}
            </p>
            <ProjectLanguages
              className="repo-languages"
              logos={repo.languages}
            />
          </div>
          {/* <div className="repo-stats">
          <div className="repo-left-stat">
            <span>
              <div className="language-color" style={{ backgroundColor: repo.node.primaryLanguage.color }}></div>
              <p>{repo.node.primaryLanguage.name}</p>
            </span>
            <span>
              <svg aria-hidden="true" className="octicon" height="16" role="img" viewBox="0 0 10 16" width="10" fill="rgb(106, 115, 125)" className="repo-star-svg">
                <path
                  fill-rule="evenodd"
                  d="M8 1a1.993 1.993 0 0 0-1 3.72V6L5 8 3 6V4.72A1.993 1.993 0 0 0 2 1a1.993 1.993 0 0 0-1 3.72V6.5l3 3v1.78A1.993 1.993 0 0 0 5 15a1.993 1.993 0 0 0 1-3.72V9.5l3-3V4.72A1.993 1.993 0 0 0 8 1zM2 4.2C1.34 4.2.8 3.65.8 3c0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm3 10c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm3-10c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2z"
                ></path>
              </svg>
              <p>{repo.node.forkCount}</p>
            </span>
            <span>
              <svg aria-hidden="true" className="octicon" height="16" role="img" viewBox="0 0 14 16" width="14" fill="rgb(106, 115, 125)" className="repo-star-svg">
                <path fill-rule="evenodd" d="M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74L14 6z"></path>
              </svg>
              <p>{repo.node.stargazers.totalCount}</p>
            </span>
          </div>
          <div className="repo-right-stat">
            <p>{repo.node.diskUsage} KB</p>
          </div>
        </div> */}
        </div>
      </Fade>
      {repo.image && (
        <div
          className="repo-card-image"
          onClick={(e) => {
            e.stopPropagation();
            setLightboxOpen(true);
          }}
        >
          <img
            src={require("../../assets/images/" + repo.image)}
            alt={repo.name}
          />
        </div>
      )}
      {lightboxOpen && repo.image && ReactDOM.createPortal(
        <div className="lightbox-overlay" onClick={(e) => {
          e.stopPropagation();
          setLightboxOpen(false);
        }}>
          <img
            className="lightbox-image"
            src={require("../../assets/images/" + repo.image)}
            alt={repo.name}
          />
        </div>,
        document.body
      )}
      {privateModalOpen && ReactDOM.createPortal(
        <div
          className="lightbox-overlay"
          onClick={(e) => {
            e.stopPropagation();
            setPrivateModalOpen(false);
          }}
        >
          <div
            className="private-repo-modal"
            style={{ backgroundColor: theme.cardBackground }}
            onClick={(e) => e.stopPropagation()}
          >
            <svg className="private-repo-lock" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <h3 className="private-repo-title" style={{ color: theme.text }}>
              {t("projects.privateRepoTitle")}
            </h3>
            <p className="private-repo-message" style={{ color: theme.secondaryText }}>
              {t("projects.privateRepo")}
            </p>
            <button
              className="private-repo-btn"
              style={{ color: theme.imageHighlight, borderColor: theme.imageHighlight }}
              onClick={() => setPrivateModalOpen(false)}
            >
              {t("projects.close")}
            </button>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
